import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { NzColDirective, NzRowDirective } from "ng-zorro-antd/grid";
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent } from "ng-zorro-antd/form";
import { NzOptionComponent, NzSelectComponent } from "ng-zorro-antd/select";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { NgIf } from "@angular/common";
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { TimesheetService } from '../../../../services/timesheet.service';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { LookupService } from '../../../../services/lookup.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { UserService } from '../../../../services/user.service';

const fields = [
  { field: 'Timeframe', show: true, default: '30 days' },
  { field: 'status', show: true },
  { field: 'status', show: true },
  { field: 'consumer', show: true },
  { field: 'consumerPplId', show: true },
  { field: 'provider', show: true },
  { field: 'providerPplId', show: true },
  { field: 'chequeNumber', show: true },
  { field: 'payPeriod', show: true },
  { field: 'paymentDate', show: true },
  { field: 'processStatusLkp', show: true },
  { field: 'serviceCode', show: true },
];

@Component({
  selector: 'ppl-timesheet-filter',
  standalone: true,
  imports: [
    ButtonComponent,
    NzColDirective,
    NzFormControlComponent,
    NzFormDirective,
    NzFormItemComponent,
    NzOptionComponent,
    NzRowDirective,
    NzSelectComponent,
    ReactiveFormsModule,
    NgIf,
    AuthorizeDirective,
    NzAutocompleteModule,
    NzDatePickerModule
  ],
  templateUrl: './timesheet-filter.component.html',
  styleUrls: ['./timesheet-filter.component.css']
})
export class TimesheetFilterComponent implements OnInit {
  @Input() filterFields: any[] = fields;
  @Input() includeBusinessStatus: any[] = [];
  @Input() processCodes: any[] = [];
  @Input() includeProcessingStatus: any[] = [];
  @Output() searchEvent = new EventEmitter<any>();
  statusList: LookupValueItem[] = [];
  processStatusList: LookupValueItem[] = [];
  filteredProcessStatusList: LookupValueItem[] = [];
  timesheetServiceCodes: LookupValueItem[] = [];

  timesheetSearchForm!: FormGroup;
  consumers = [
    { id: 'PRC-NY-10000802', name: 'Nikhil Malhotra' },
    { id: 'PRC-NY-10000801', name: 'Henderson Branch' },
    { id: 'PRC-NY-10000797', name: 'Renata Laugherane' },
    { id: 'PRC-NY-10000796', name: 'Torry Hunton' },
    { id: 'PRC-NY-10000804', name: 'Gwenni Malhotra' },
  ];

  providers = [
    { id: 'PRC-NY-10000802', name: 'Nikhil Malhotra' },
    { id: 'PRC-NY-10000801', name: 'Henderson Branch' },
    { id: 'PRC-NY-10000797', name: 'Renata Laugherane' },
    { id: 'PRC-NY-10000796', name: 'Torry Hunton' },
    { id: 'PRC-NY-10000804', name: 'Gwenni Malhotra' },
  ];

  filteredConsumers: any[] = [];
  filteredProviders: any[] = [];
  status = [
    { id: '1', name: 'Approved' },
    { id: '2', name: 'Rejected' },
    { id: '3', name: 'In Review' },
  ];

  loopback = [
    { val: '30 days' },
    { val: '60 days' },
    { val: '90 days' },
    { val: '120 days' },
    { val: '150 days' },
    { val: '180 days' },
  ];


  pageId: string = '';
  tabId: string = '';
  programName!: string;
  payPeriod: any[] = [];

  constructor(private fb: FormBuilder, private timesheetService: TimesheetService,
    private lookupService: LookupService, private dateTimeFormatter: DateTimeFormatterService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    const formFields = this.filterFields.reduce((acc, f) => {
      if (f.show) {
        acc = { ...acc, [f.field]: [f.default ? f.default : null] };
      }
      return acc;
    }, {});
    this.timesheetSearchForm = this.fb.group(formFields);

    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    const businessStatusList = this.lookupService.getLookupValue('Business Status')
    this.statusList = this.includeBusinessStatus.length ? businessStatusList.filter((status: any) => {
      return this.includeBusinessStatus.includes(status.lkpValueCode);
    }) : businessStatusList;

    const processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.processStatusList = this.includeProcessingStatus.length ? processingStatusList.filter((status: any) => {
      return this.includeProcessingStatus.includes(status.lkpValueCode);
    }) : processingStatusList;
    this.filteredProcessStatusList = processingStatusList.filter(status => status.lkpValueCode === 'SB' || status.lkpValueCode === 'PE'
      || status.lkpValueCode === 'TP' || status.lkpValueCode === 'SE' || status.lkpValueCode === 'AC');

    this.timesheetServiceCodes = this.lookupService.getLookupValue('timesheet_filter_serviceCode');

    this.getPayPeriod();
  }

  getPayPeriod() {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        this.payPeriod = data.responsedata;
      });
  }

  onInput(e: Event, fieldName: string): void {
    const value = (e.target as HTMLInputElement).value;

    if (fieldName === 'consumer') {
      this.filteredConsumers = value ? this.consumers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    } else if (fieldName === 'provider') {
      this.filteredProviders = value ? this.providers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    }

  }

  search() {
    this.searchEvent.emit(this.timesheetSearchForm.value);
  }
}
